import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {useFileViewerStore} from '@components/file-viewer/file-viewer-store'

const TwButton = tw.div`
  flex
  select-none
  items-center
  gap-8
  cursor-pointer
  py-4
  px-8
  rounded-4
  hover:bg-project-hover-old-dark
  active:bg-main-old-dark
`

const TwText = tw.div`
  font-normal
  truncate
  leading-4
  text-14
  text-secondary-old-dark
`

export const CoverControls = observer(() => {
  const [, store] = useFileViewerStore()

  return (
    <TwButton onClick={store.setAsCover}>
      <Icon icon="IconPhoto" />
      <TwText>{Lang.msg.setTaskImage}</TwText>
    </TwButton>
  )
})
